import { useQuery } from "@tanstack/react-query";
import { httpClient } from "@/api/client";
import { getInnrapporteringsFristerOptions } from "@/api/generated/@tanstack/react-query.gen";
import { addDaysToDate } from "@/utils/dateTimeUtils";

export const useKjøreplaner = (): {
  kjøreplaner: Date[];
  nesteKjøreplan: Date | null;
  isLoading: boolean;
  isError: boolean;
} => {
  const { data, isLoading, isError } = useQuery({
    ...getInnrapporteringsFristerOptions({
      client: httpClient,
    }),
  });

  const kjøreplaner =
    data?.frister
      .flatMap((d) => [
        d.innrapporteringsFristEksklusiv,
        ...d.ekstraordinæreInnrapporteringsFristerEksklusiv,
      ])
      .filter((p) => p != null)
      .map((p) => addDaysToDate(new Date(p), 0))
      .sort((a, b) => a.getTime() - b.getTime())
      // Fjern eventuelle duplikater
      .filter(
        (date, index, arr) =>
          index === 0 || date.getTime() !== arr[index - 1].getTime(),
      ) ?? [];

  const nesteKjøreplan = kjøreplaner.find((date) => date > new Date()) || null;

  return {
    kjøreplaner,
    nesteKjøreplan,
    isLoading,
    isError,
  };
};
